import { render, staticRenderFns } from "./Courses_inprogress.vue?vue&type=template&id=363a04d0&scoped=true&"
import script from "./Courses_inprogress.vue?vue&type=script&lang=js&"
export * from "./Courses_inprogress.vue?vue&type=script&lang=js&"
import style0 from "./Courses_inprogress.vue?vue&type=style&index=0&id=363a04d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363a04d0",
  null
  
)

export default component.exports